import React, { useState, useEffect } from "react";
import { supabase } from "../config/supabase";
import LoginForm from "./LoginForm";
import AdminPage from "../pages/AdminPage";

const AuthGuard: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    // Controlla se l'utente è già autenticato
    const checkAuth = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setAuthenticated(!!session);
      setLoading(false);
    };

    checkAuth();

    // Ascolta i cambiamenti di autenticazione
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      setAuthenticated(!!session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleLoginSuccess = () => {
    setAuthenticated(true);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-soft-pink via-soft-yellow to-soft-blue">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-pink-300 border-t-pink-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Controllo autenticazione...</p>
        </div>
      </div>
    );
  }

  if (authenticated) {
    return <AdminPage />;
  }

  return <LoginForm onLogin={handleLoginSuccess} />;
};

export default AuthGuard;
